export default __webpack_public_path__ + "static/media/arrow.f7301c54.svg";